export default class DndKeyTableEnum {
    static get folder() {
      return "folder";
    }
    static get default() {
        return "default";
      }
  }
  